<template>
	<div 
		class="container-section-us"
		:class="{
			'color-section-us': tabs.name === 'detail-product',
			'transition-history': tabs.name === 'history',
		}"
	>
		<btn-edit
			v-if="editable"
			class="top-responsive"
			background="#001d32"
			icon="edit-white"
			@edit-section="openModal"
		/>
		<div class="app-wrapper">
			<div class="app-wrapper--relative">
				<div 
					class="us-list-tabs"
					:class="{ 'with-nav-history': tabs.name === 'history',
						'with-nav-us': tabs.name === 'about',
						'with-nav-detail': tabs.name === 'detail-product' }"
					>
					<template v-for="(tab, key, index) in tabs">
						<a
							:key="index"
							v-if="key !== 'id' && key !== 'name' && key !== 'title' && key !== 'images'"
							href="/"
							:ref="tabs.name"
							class="us-list-tab"
							:class="{ 'select-tab': currentSlide === index }"
							@click.prevent="updateCurrentType(index)" 
						>{{ tab.title }}</a>
					</template>
				</div>
				<select
					class="form-input mobile"
					v-if="tabs"
					v-model="currentTab" @change="updateCurrentType('mobile')">
					<option
						v-for="(tab, key, index) in tabs"
						:key="index"
						:value="index"
						v-if="key !== 'id' &&
							key !== 'name' &&
							key !== 'title' &&
							key !== 'images'">{{ tab.title }}</option>
					<option
						v-if="this.tabs.name !== 'history'"
						value="0">Nosotros</option>
				</select>
			</div>
		</div>
		<div>
			<slider 
				:options="optionsParent"
				@slide="updateCurrentSlide"
				class="slider-parent"
				ref="slider-parent">
				<template v-for="(tab, key, index) in tabs">
					<slideritem
						:key="index"
						v-if="key !== 'id' && key !== 'name' && key !== 'title' && key !== 'images'">
						<div
							:class="{
								'app-wrapper': true,
								'app-wrapper--history': tabs.name === 'history',
							}">
							<div class="wrapper-item">
								<div 
									:style="`background-image: url(${tab.images[0]})`"
									class="slider-image"
									v-if="tabs.name === 'history'"
								></div>
								<div class="wrapper-text">
									<div :class="{ 'wrapper-text--history': tabs.name === 'history' }">
										<a
											class="wrapper-text__link"
											v-if="tab.link"
											target="_blank"
											:href="tab.link"></a>
										<h4 
											:class="{ 'font-size-history year-tab': tabs.name === 'history',
												'font-size-us title-section-tab': tabs.name === 'about' }">
											{{ tab.title }}
										</h4>
										<div 
											class="item-details">
											<div v-html="tab.description"></div>
											<div v-if="false && tab.title === 'Certificaciones'" class="wrapper-buttons">
												<a class="btn-tab" target="_blank" :href="tab.images[0]">
													Descargar Certificación
													<simple-svg
														class="download-tab"
														:filepath="'/static/img/detail-download.svg'"
														:fill="'#002c55'"
														width="16"
													/>
												</a>
											</div>
										</div>
									</div>
								</div>
								<div 
									class="wrapper-slider"
									v-if="tabs.name === 'about'">
									<slider
										class="slider-child"
										:options="options"
										:ref="`slider-child-${index}`"
									>
										<slideritem 
											v-for="(item, indexSlider) in tab.images" 
											:key="indexSlider">
											<div class="wrapper-slider">
												<a
													v-if="tab.title === 'Certificaciones'"
													target="_blank"
													:href="tab.link">
													<img
														class="video-desktop"
														:src="tab.images[0]"
														alt="ISO 9001" />
												</a>
												<img
													v-else
													:src="item" alt="" class="video-desktop" />
												<!-- <p>slider-child-{{index}}</p> -->
											</div>
										</slideritem>
									</slider>
									<div class="wrapper-buttons-slider"
											v-if="tab.images.length > 1">
										<button 
											class="btn-white btn-left"
											@click="prevSlider(`slider-child-${index}`)">
											<img 
												src="/static/img/arrow-left.svg" 
												alt="mover hacia la izquierda"
												height="20px"
											>
										</button>
										<button 
											class="btn-white btn-right"
											@click="nextSlider(`slider-child-${index}`)">
											<img 
												src="/static/img/arrow-rigth.svg" 
												alt="mover hacia la derecha"
												height="20px">
										</button>
									</div>
								</div>
							</div>
						</div>
					</slideritem>
				</template>
			</slider>
		</div>
		<edit-modal-section
			v-if="open"
			:items="items"
			:title="title"
			@close-modal="closeModal"
			@save="save"
			@send-image="getImage"
			@send-image-push="getImagePush"
			@delete-image="deleteImage"
		/>
	</div>
</template>

<script>
import btnEdit from '@/components/commons/btn-edit';
import editModalSection from '@/components/commons/edit-modal-section';
import { slider, slideritem } from 'vue-concise-slider';

function data() {
	return {
		currentTab: 0,
		currentImage: '',
		items: {},
		open: false,
		title: '',
		options: {
			currentPage: 0,
			centeredSlides: true,
			speed: 1000,
			pagination: false,
		},
		currentSlide: 0,
	};
}

const computed = {
	optionsParent() {
		return {
			effect: this.tabs.name === 'history' ? 'fade' : 'slide',
			currentPage: 0,
			speed: 1000,
			pagination: false,
		};
	},
};

function closeModal() {
	this.open = false;
	this.items = {};
	this.title = '';
}

function getImage(image, index) {
	this.items[index].images[0] = image;
}

function getImagePush(image, index) {
	this.items[index].images.push(image);
}

function open(value) {
	this.onModal(value);
}

function openModal() {
	console.log('tabs', this.tabs);
	this.items = { ...this.tabs };
	this.title = this.tabs.title || 'Editar Sección';
	this.open = true;
}

async function save(body) {
	const newItems = { ...body };
	delete newItems.id;
	delete newItems.name;
	delete newItems.title;
	const newBody = {
		id: this.items.id,
		name: process.env.APP_NAME,
		flagActive: 1,
		tagId: 1,
		dataSections: {
			[this.tabs.name]: { ...newItems },
		},
	};
	try {
		await this.$http.put(`edit/pages/${this.items.id}`, newBody);
		this.showNotification('Los cambios han sido aplicados correctamente.');
		this.closeModal();
		this.$emit('section-updated');
	} catch (err) {
		if (err.status === 500) {
			this.showError();
		}
	}
}

function tabs(values) {
	const self = this;
	if (values) {
		setTimeout(() => {
			if (self.$refs[self.tabs.name] && self.$refs[self.tabs.name].length > 0) {
				self.$refs[self.tabs.name][0].click();
			}
		}, 2000);
	}
}

function updateCurrentType(index) {
	if (index === 'mobile') {
		const tab = this.tabs.name === 'about' ? this.currentTab - 1 : this.currentTab;
		this.currentSlide = this.tabs.name === 'about' ? tab + 1 : tab;
		this.$refs['slider-parent'].$emit('slideTo', tab);
	} else {
		const tab = this.tabs.name === 'about' ? index - 1 : index;
		this.currentSlide = this.tabs.name === 'about' ? tab + 1 : tab;
		this.$refs['slider-parent'].$emit('slideTo', tab);
	}
}

function deleteImage(key, index, indexImage) {
	this.items[key].images.splice(indexImage, 1);
	const ref = `slider-child-${index}`;
	this.$refs[ref][0].$emit('slideTo', 0);
}

function prevSlider(ref) {
	this.$refs[ref][0].$emit('slidePre');
}

function nextSlider(ref) {
	this.$refs[ref][0].$emit('slideNext');
}

function updateCurrentSlide(slide) {
	this.currentSlide = this.tabs.name === 'about' ? slide.currentPage + 1 : slide.currentPage;
}

export default {
	name: 'app-tab',
	components: {
		btnEdit,
		editModalSection,
		slider,
		slideritem,
	},
	data,
	methods: {
		closeModal,
		getImage,
		openModal,
		save,
		updateCurrentType,
		getImagePush,
		deleteImage,
		prevSlider,
		nextSlider,
		updateCurrentSlide,
	},
	computed,
	props: {
		tabs: {
			type: Object,
		},
		product: {
			type: Object,
			default: () => {},
		},
	},
	watch: {
		open,
		tabs,
	},
};
</script>

<style lang="scss">
.container-section-us {
	&.transition-history {
		.slider-wrapper {
			min-height: 550px;
		}

		.slider-item {
			@include transition();

			&.slider-active {
				@include opacity(1);
			}
		}
	}
}

.swiper-container-horizontal {
	&.slider-parent > * > .slider-wrapper {
		align-items: flex-start;
	}
}
</style>


<style lang="scss" scoped>
.slider-active {
	z-index: 999 !important;
}

.app-wrapper {
	&--history {
		max-width: 100%;
		padding-top: 150px;
		min-height: 550px;
		width: 100%;

		.wrapper-text {
			margin: 0 auto;
			max-width: 1180px;
			text-align: left;
			width: 90%;

			&--history {
				max-width: 550px;
			}

			&__link {
				bottom: 0;
				cursor: pointer;
				position: absolute;
				right: 0;
				top: 0;
				width: 50%;
			}
		}
	}
}

.slider-child {
	.slider-item {
		max-height: 400px;
	}
}

.container-section-us {
	padding: 60px 0 40px;

	&.transition-history {
		padding: 0;
		min-height: auto;

		> .app-wrapper {
			position: absolute;
			top: 40px;
			left: 0;
			right: 0;
			z-index: 7;

			&--relative {
				margin: 0 auto;
				max-width: 1180px;
				width: 90%;
			}

			@media (max-width: 964px) {
				top: 60px;
			}
		}
	}
}

.us-list-tabs {
	@include display-flex;
	margin-bottom: 40px;
	overflow: auto;
	z-index: 4;

	.us-list-tab {
		@include transition(border .3s linear 0s);
		@include font-size(13);
		padding: 10px 20px;
		border-bottom: 1px solid map-get($colors, black-dark);

		&.select-tab {
			border-bottom: 2px solid map-get($colors, red-dark);
		}
	}

	&.with-nav-detail {
		width: 30%;
	}
}

.year-tab {
	@include font-maison-bold;
	@include font-size(80);
	@include opacity(.3);
	color: map-get($colors, black-dark);
}

.item-details {
	@include font-size(15);
	color: map-get($colors, text);
	line-height: 25px;
	position: relative;
	text-align: justify;
}

.call-video-icon {
	@include transform(translate(-50%, -50%));
	left: 50%;
	position: absolute;
	top: 50%;
}

	.title-section-tab {
		@include font-maison-bold();
		color: map-get($colors, black-dark);
		text-align: center;

		&.font-size-history {
			@include font-size(18);
		}

		&.font-size-us {
			@include font-size(36);
			line-height: normal;
		}
	}


	.video-desktop {
		max-height: 400px;
		max-width: 100%;
	}

	.container-video {
		float: right;
		height: 348px;
		margin-left: 76px;
		position: relative;
		width: 485px;

		&.top-us {
			margin-bottom: 40px;
			margin-top: -59px;
		}

		&.top-detail {
			height: auto;
			margin-top: -93px;
		}
	}


	.container-section-us {
		background-position: center;
		background-size: cover;
		min-height: 550px;
		position: relative;

		&.color-section-us {
			background: map-get($colors, background-products);
			padding: 180px 106px;
		}
	}

	.title-section-tab {
		@include font-size(36);
		margin-bottom: 25px;
		text-align: left;
	}

	.select-tab {
		border-bottom: 2px solid map-get($colors, red-dark);
	}

	.container-section-us-title {
		@include font-maison-bold;
		@include font-size(36);
		color: map-get($colors, black-dark);
		margin-bottom: 35px;
		text-align: center;
	}

	.wrapper-buttons {
		@include display-flex;
		margin-bottom: 10px;
		margin-top: 30px;
	}

	.btn-tab {
		@include font-maison-medium;
		@include flex-center;
		@include border-radius(3px);
		@include font-size(13);
		border: 1px solid map-get($colors, black-dark);
		color: map-get($colors, black-dark);
		margin-right: 11px;
		padding: 8px 12px;
	}

	.download-tab {
		height: 16px;
		margin-left: 10px;
	}

	.line {
		background: map-get($colors, black-dark);
		bottom: 0;
		height: 11px;
		left: 0;
		position: absolute;
		width: 100%;
	}

	.products-tab-thumbnails {
		@include flex-center();
			.wrapper-image-thumbnails {
				border: 2px solid transparent;
				cursor: pointer;
				height: 70px;
				margin: 0 12px;
				outline: none;
				width: 70px;

				&.tns-nav-active {
					border-color: map-get($colors, black-dark);
				}
		}
	}

	.image-history {
		bottom: 0;
		height: auto;
		margin-top: auto !important;
		position: absolute;
		right: 0;
		top: 0;
	}

	.background-white {
		bottom: 0;
		left: -45px;
		position: absolute;
		right: 0;
		top: 0;
	}

	.transition-history {
		.container-video {
			margin-bottom: 0;
		}

		.text-history {
			width: 45%;
		}

		.container-video {
			width: 50%;
		}

		.video-desktop {
			height: 100%;
			width: 100%;
			object-fit: cover;
		}
	}

	.wrapper-slider {
		position: relative;
		flex: 1;
	}

	.wrapper-buttons-slider {
		@include transform(translateY(-50%));
		height: 40px;
		position: absolute;
		top: 50%;
		width: 100%;
		z-index: 5;

		.btn-white {
			@include flex-center();
			@include border-radius(50%);
			@include box-shadow(0, 2px, 7px, 0, rgba(144, 144, 144, 0.5));
			background: map-get($colors, white);
			height: 40px;
			width: 40px;
		}

		.btn-right {
			position: absolute;
			right: -20px;
		}

		.btn-left {
			left: -20px;
			position: absolute;
		}
	}

	.wrapper-item {
		@include display-flex();
		align-items: flex-start;
		justify-content: space-between;
	}

	.wrapper-text {
		width: 533px;

		@media (min-width: 964px) {
			margin-right: 50px;
		}
	}

	.slider-image {
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
		bottom: 0;
		left: 0;
		position: absolute;
		right: 0;
		top: 0;
		
		&::before {
			@include linear-gradient(
				90deg,
				rgba(255, 255, 255, 1),
				rgba(255, 255, 255, .9),
				rgba(255, 255, 255, .7),
				transparent,
				transparent
			);
	 		bottom: 0;
			content: "";
			left: 0;
			position: absolute;
			right: 0;
			top: 0;
		}
	}

	@media (max-width: 1066px) {
		.wrapper-buttons-slider {
			.btn-right {
				right: -5px;
			}

			.btn-left {
				left: -5px;
			}
		}

		.slider-image {
			&::before {
				background-color: hsla(0,0%,100%,.8);
				background-image: none;
			}
 		}

		.background-white {
			display: none;
		}

		.wrapper-item {
			flex-direction: column;
			padding: 90px 12px 12px;
		}

		.wrapper-text {
			width: auto;
		}

		.wrapper-slider {
			position: relative;
			width: 100%;
		}
		
		.section-us-tab-content {
			@include display-flex;
			align-items: center;
			flex-direction: column;
			padding: 0 24px;
		}

		.container-video{
			height: 242px;
			margin: 21px 0 0 0;
			order: 2;
			width: auto;

			&.top-us {
				margin-top: 20px;
			}

			&.top-detail {
				height: auto;
				margin-top: 72px;
			}
		}

		.us-list-tabs {
			&.with-nav-us {
			}

			&.with-nav-detail {
				width: 100%;
			}

			&.with-nav-history {
				width: 100%;
			}

			.us-list-tab {
				@include font-size(11);
			}
		}

		.container-section-us {
			&.color-section-us {
				padding-top: 36px;
			}
		}

		.wrapper-buttons {
			align-items: center;
			flex-direction: column;
			margin-bottom: 0;

			.btn-tab {
				margin-bottom: 16px;
				margin-right: 0;
			}

			.btn-tab:nth-child(2) {
				width: 134px;
			}
		}

		.title-section-tab {
			@include font-size(20);

			&.font-size-us {
				@include font-size(14);
			}
		}

		.container-section-us {
			&.color-section-us {
				padding: 40px 0px;
			}
		}

		.image-history {
			position: relative;
		}

		.item-details {
			min-height: 299px;
		}

		.transition-history {
			.text-history {
				width: 100%;
			}

			.container-video {
				width: 100%;
			}
		}
	}

	.mini-images {
		display: flex;
		flex-direction: column;
		justify-content: flex-start;
		left: 100%;
		position: absolute;
		top: 0;
	}

	.tiny-image {
		border: 1px solid map-get($colors, grey-text);
		height: 70px;
		object-fit: contain;
		margin-bottom: 10px;
		width: 70px;
	}

	.tiny-image-active {
		border: 5px solid map-get($colors, black-dark);
	}

	.top-responsive {
		top: 5px !important;

		@media (min-width: 964px) {
			top: 37 !important;
		}
	}

	@media (max-width: 964px) {
		.wrapper-item {
			padding: 12px;
		}
	}

.mobile {
	display: none;
}

@media screen and (max-width: 600px) {
	.container-section-us {
		padding: 30px 0;
	}

	.us-list-tabs {
		display: none;
	}

	.mobile {
		display: block;
	}

	.form-input {
		margin-bottom: 20px;
	}
}
</style>

<style lang="scss">
.item-details {
	ul, ol {
		list-style: disc;
		margin-left: 18px;
	}

	a {
		text-decoration: underline;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/commons/app-tab.vue